module.exports = __webpack_public_path__ + "static/media/search.ed1d65f4.svg";